/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fleet_DirectionInputs */

const vi_fleet_direction = /** @type {(inputs: Fleet_DirectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hướng`)
};

/**

* @param {Fleet_DirectionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fleet_direction = /** @type {((inputs?: Fleet_DirectionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fleet_DirectionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fleet_direction(inputs)
});